import { AnyObject } from 'common/interfaces';

export enum RecordStatuses {
  APPROVED_RECORD = 752560001,
  OPENED_RECORD = 752560000,
  CANCELED_RECORD = 752560003,
  REJECTED_RECORD = 752560002
}

export enum FilterNames {
  StartDate = 'from',
  EndDate = 'to',
  Status = 'status',
  FleetState = 'statecode',
  Booking = 'name',
  Mark = 'kennzeichen',
  Location = 'standort',
  Driver = 'fahrer'
}

export const emptyFilterState = {
  date: null,
  [FilterNames.Status]: [],
  [FilterNames.FleetState]: [],
  [FilterNames.Booking]: null,
  [FilterNames.Mark]: null,
  [FilterNames.Location]: [],
  [FilterNames.Driver]: null
};

export type TableParams = {
  pagination?: {
    start?: number;
    number?: number;
  };
  sort: { predicate: string; reverse: boolean };
  searchParams: AnyObject;
};
